// Leads = every form submission (contact, assessment callback, anonymous message, admission).
// LIVE (REACT_APP_API_BASE set): POST to website_api/enquiries/ -> software: Website > Enquiries.
// Otherwise: stored in the visitor's localStorage so the flow can be tested end-to-end.
import { LIVE, apiPost } from "./client";

const STORAGE_KEY = "uhc_leads";
const SUBMIT_DELAY_MS = 600;

export const LEAD_TYPES = {
  APPOINTMENT: "appointment",
  CONTACT: "contact",
  ASSESSMENT: "assessment",
  ANONYMOUS: "anonymous",
  ADMISSION: "admission",
};

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  } catch {
    return [];
  }
}

export function submitLead(type, payload) {
  if (LIVE && type !== LEAD_TYPES.APPOINTMENT) {
    const page = typeof window !== "undefined" ? window.location.pathname : "";
    return apiPost("/website_api/enquiries/", { type, page, ...payload });
  }
  const lead = {
    id: `L${Date.now()}`,
    type,
    status: "new",
    createdAt: new Date().toISOString(),
    page: typeof window !== "undefined" ? window.location.pathname : "",
    ...payload,
  };

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        const all = readAll();
        all.unshift(lead);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(all.slice(0, 200)));
        resolve({ success: true, id: lead.id });
      } catch (e) {
        reject(
          new Error("Could not send your request. Please call us instead."),
        );
      }
    }, SUBMIT_DELAY_MS);
  });
}

// Handy for checking submissions during development (browser console: window.__uhcLeads())
export const getLeads = () => readAll();
if (typeof window !== "undefined") window.__uhcLeads = getLeads;
